import { Card, CardContent, Grid } from '@material-ui/core';
import { makeStyles } from '@material-ui/styles';
import PropTypes from 'prop-types';
import React from 'react';
import { useTranslation } from 'react-i18next';
import MaskedInput from 'react-text-mask';
import servisAkademi from 'src/assets/images/servisAkademi.png';
import { getUser } from 'src/utils/Common';

const useStyles = makeStyles(theme => ({
  root: {},
  fields: {
    margin: theme.spacing(-1),
    display: 'flex',
    flexWrap: 'wrap',
    '& > *': {
      flexGrow: 1,
      margin: theme.spacing(1)
    }
  },
  submitButton: {
    marginTop: theme.spacing(1),
    width: '100%'
  }
}));

function TextMaskCustom(props) {
  const { inputRef, ...other } = props;
  return (
    <MaskedInput
      {...other}
      ref={ref => {
        inputRef(ref ? ref.inputElement : null);
      }}
      mask={[
        '(',
        /[1-9]/,
        /\d/,
        /\d/,
        ')',
        ' ',
        /\d/,
        /\d/,
        /\d/,
        '-',
        /\d/,
        /\d/,
        /\d/,
        /\d/
      ]}
      placeholderChar={'\u2000'}
      guide={false}
      showMask
    />
  );
}
function Kayit({ className, ...rest }) {
  const SessionUser = getUser();
  const { t } = useTranslation('profile');
  const classes = useStyles();

  return (
    <Card>
      <CardContent className={classes.icon}>
        <Grid container justify="space-between">
          <Grid item xs={12} className={classes.icon}>
            <a
              href="https://globalcustomercare.arcelikacademy.com/login"
              target="_blank"
              rel="noopener noreferrer"
            >
              <img
                width="100%"
                height="100%"
                src={servisAkademi}
                border="0"
                alt="Servis Akademi"
              />
            </a>
          </Grid>
        </Grid>
      </CardContent>
    </Card>
  );
}
Kayit.propTypes = {
  className: PropTypes.string
};

export default Kayit;
